import {Badge, Button, Card, Col, Descriptions, Divider, List, Row, Skeleton, Spin, Typography} from "antd";
import '../asset/less/Billing.css'
import {CreditCardOutlined} from "@ant-design/icons";
import mastercard from "../asset/image/mastercard-logo.png";
import visa from "../asset/image/visa-logo.png";
import {withRouter} from "react-router";
import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {createBillingPortal, getCustomerInfo, getCustomerInvoices, getPaymentMethods} from "../api/stripe";
import {getArtist} from "../api/artists";
import Subscription from '../pages/subscription/Subscription'
//import { URL_BILLING_ADD_METHOD, URL_INCOME_ORDER } from '../const';
const {Title} = Typography;
const mapStateToProps = function (state) {
    return {
        artistId: state.user.info.artistId,
        userId: state.user.info.userId,
    }
}
export default withRouter(connect(mapStateToProps)(Billing));

function Billing(props) {
    const wifi = [
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 22.5 20.625"
            key={0}
        >
            <g id="wifi" transform="translate(0.75 0.75)">
                <circle
                    id="Oval"
                    cx="1.5"
                    cy="1.5"
                    r="1.5"
                    transform="translate(9 16.875)"
                    fill="#fff"
                ></circle>
                <path
                    id="Path"
                    d="M0,1.36a6.377,6.377,0,0,1,7.5,0"
                    transform="translate(6.75 11.86)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="1.5"
                ></path>
                <path
                    id="Path-2"
                    data-name="Path"
                    d="M14.138,2.216A12.381,12.381,0,0,0,0,2.216"
                    transform="translate(3.431 6)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="1.5"
                ></path>
                <path
                    id="Path-3"
                    data-name="Path"
                    d="M0,3.294a18.384,18.384,0,0,1,21,0"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="1.5"
                ></path>
            </g>
        </svg>,
    ];
    const pencil = [
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            key={0}
        >
            <path
                d="M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z"
                className="fill-gray-7"
            ></path>
            <path
                d="M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z"
                className="fill-gray-7"
            ></path>
        </svg>,
    ];
    const download = [
        <svg
            width="15"
            height="15"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            key="0"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 17C3 16.4477 3.44772 16 4 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H4C3.44772 18 3 17.5523 3 17ZM6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L9 10.5858L9 3C9 2.44772 9.44771 2 10 2C10.5523 2 11 2.44771 11 3L11 10.5858L12.2929 9.29289C12.6834 8.90237 13.3166 8.90237 13.7071 9.29289C14.0976 9.68342 14.0976 10.3166 13.7071 10.7071L10.7071 13.7071C10.5196 13.8946 10.2652 14 10 14C9.73478 14 9.48043 13.8946 9.29289 13.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z"
                fill="#111827"
            ></path>
        </svg>,
    ];
    const [billingPortalURL, setBillingPortalURL] = useState("");
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [defaultPMID, setDefaultPMID] = useState("");
    const [invoices, setInvoices] = useState([]);
    const [defaultPaymentMethod, setDefaultPaymentMethod] = useState(null);
    const [loading, setLoading] = useState(false);
    const [plan, setPlan] = useState('');
    const [customerId, setCustomerId] = useState(null)
    const getCardImage = (cardType) => {
        if (cardType === "mastercard") {
            return mastercard;
        } else {
            return visa;
        }
    }

    const stateSetter = (responses) => {
        setBillingPortalURL(responses[0].data.url)
        setPaymentMethods(responses[1].data.data)
        setDefaultPMID(responses[2].data.invoice_settings.default_payment_method)
        setInvoices(responses[3].data.data)
    }

    useEffect(() => {
        if (!props.userId) return
        setLoading(true)
        getArtist(props.userId)
            .then((response) => {
                setPlan(response.data.sam_plan)
                if (response.data.sam_plan_user_id) {
                    setCustomerId(response.data.sam_plan_user_id)
                    Promise.all([
                        createBillingPortal(response.data.sam_plan_user_id),
                        getPaymentMethods(response.data.sam_plan_user_id),
                        getCustomerInfo(response.data.sam_plan_user_id),
                        getCustomerInvoices(response.data.sam_plan_user_id)
                    ]).then((responses) => {
                        stateSetter(responses)
                    }).finally(() => {
                        setLoading(false)
                    })
                } else {
                    setCustomerId(null)
                    setLoading(false)
                }
            }).catch((error) => {
            console.log(error)
        }).finally(() => {
            setLoading(false)
        })

    }, [defaultPMID])

    const getDateStr = (timestamp) => {
        const date = new Date(timestamp * 1000);

        const month = date.getMonth() + 1;
        const day = date.getDate();
        const year = date.getFullYear();

        return `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`;
    }

    const paymentCard = (paymentMethod) => {
        return (
            <>
                <Card className="payment-method-card">
                    <img src={getCardImage(paymentMethod.card.brand)} alt={"card"}/>
                    <h6 className="card-number">**** **** **** {paymentMethod.card.last4}</h6>
                    <Button type="link" className="ant-edit-link">
                        {pencil}
                    </Button>
                </Card>
            </>
        )
    }

    return (
        <Spin size='large' spinning={loading}>
            <Row align='bottom' gutter={{xs: 8, sm: 16, md: 24}}>
                <Col>
                    <Title style={{marginBottom: 16}}>
                        <CreditCardOutlined style={{marginRight: 8}}/>
                        Billing
                    </Title>
                </Col>
            </Row>
            <Row gutter={[24, 0]}>
                <Col xs={24} xl={8} className="mb-24">
                    <Card
                        title={wifi}
                        bordered={false}
                        className="card-credit header-solid h-ful"
                    >
                        <h5 className="card-number">**** **** **** {defaultPaymentMethod?.card.last4}</h5>

                        <div className="card-footer">
                            <div className="mr-30">
                                <p>Card Holder</p>
                                <h6>{defaultPaymentMethod?.billing_details.name}</h6>
                            </div>
                            <div className="mr-30">
                            </div>
                            <div className="card-footer-col col-logo ml-auto">
                                <img src={getCardImage(defaultPaymentMethod?.card.brand)}/>
                            </div>
                        </div>
                    </Card>
                    <Card
                        bordered={true}
                        className="header-solid ant-invoice-card"
                    >
                        <Row gutter={[24, 0]} className="ant-row-flex ant-row-flex-middle">
                            <Col xs={7} md={13} lg={24} xl={15}>
                                <Title level={5} className="font-semibold m-0">Invoices</Title>
                            </Col>
                            <Col xs={12} md={12} xl={6} className="d-flex">
                                <Button type="primary" disabled={!customerId} onClick={() => {
                                    window.location.href = billingPortalURL
                                }}>View All</Button>
                            </Col>
                        </Row>
                        <List
                            itemLayout="horizontal"
                            className="invoice-list"
                            dataSource={invoices}
                            renderItem={(item) => (
                                <List.Item
                                    actions={[<Button type="link" style={{marginTop: 12}} href={item.invoice_pdf}
                                                      target={'_blank'}>{download} PDF</Button>]}
                                >
                                    <List.Item.Meta
                                        title={getDateStr(item.effective_at)}
                                        description={item.number}
                                    />
                                    <div className="amount">${item.amount_paid / 100}</div>
                                </List.Item>
                            )}
                        />
                    </Card>
                </Col>
                <Col xs={24} xl={16} className="mb-24">
                    <Card
                        className="header-solid h-full ant-card-p-0"
                        bordered={true}
                    >
                        <Row gutter={[24, 12]} className="ant-row-flex ant-row-flex-middle">
                            <Col xs={24} md={15} lg={15} xl={18}>
                                <Title level={5} className="font-semibold m-0">Payment Methods</Title>
                            </Col>
                            <Col xs={24} md={9} lg={5} className="d-flex">
                                {/*<AddMethod artistId={props.artistId}/>*/}
                                <Button type="primary" onClick={() => {
                                    window.location.href = billingPortalURL
                                }} disabled={!customerId}>
                                    View Billing Portal
                                </Button>
                            </Col>
                        </Row>
                        <Row gutter={[24, 0]}>
                            {paymentMethods.map(paymentMethod => (
                                    <Col span={24} md={12}>
                                        {paymentMethod.id === defaultPMID && (
                                            <Badge.Ribbon text={'default'}>
                                                {paymentCard(paymentMethod)}
                                            </Badge.Ribbon>
                                        )}
                                        {paymentMethod.id !== defaultPMID && (
                                            paymentCard(paymentMethod)
                                        )}
                                        {paymentMethod.billing_details.email && (
                                              <Card className="card-billing-info" bordered="false">
                                                {!loading && (
                                                    <div className="col-info">
                                                        <Descriptions title={paymentMethod.billing_details.name || "-"}>
                                                            <Descriptions.Item label="Email Address" span={3}>
                                                                {paymentMethod.billing_details.email || "-"}
                                                            </Descriptions.Item>
                                                            <Descriptions.Item label="Billing Address">
                                                                {paymentMethod.billing_details.address.line1 || "- "}, {paymentMethod.billing_details.address.city || "- "}, {paymentMethod.billing_details.address.state || "-"} {paymentMethod.billing_details.address.postal_code}
                                                            </Descriptions.Item>
                                                        </Descriptions>
                                                    </div>
                                                )}
                                                {loading && (
                                                    <div className="col-info">
                                                        <Skeleton style={{width: '100%', height: 320}}/>
                                                    </div>
                                                )}
                                            </Card>
                                        )}
                                    </Col>
                                )
                            )}
                        </Row>
                    </Card>
                </Col>
                <Divider/>
            </Row>
            <Subscription titleVisible={true}/>
        </Spin>
    );
}